import ProductAlert from "./ProductAlert.jsx";

export default ProductAlert;
